import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FiltersProvider } from "@/context/FiltersContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DailyLog from "@/pages/DailyLog";
import TieUps from "@/pages/TieUps";
import Targets from "@/pages/Targets";
import Scorecard from "@/pages/Scorecard";
import Events from "@/pages/Events";
import Executives from "@/pages/Executives";
import AIAssistant from "@/pages/AIAssistant";
import ImportPage from "@/pages/ImportPage";
import Goals from "@/pages/Goals";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-slate-400 min-h-screen bg-[#0F172A]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RoleOnly({ roles, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="daily-log" element={<DailyLog />} />
        <Route path="tieups" element={<TieUps />} />
        <Route path="events" element={<Events />} />
        <Route path="goals" element={<Goals />} />
        <Route path="scorecard" element={<Scorecard />} />
        <Route path="targets" element={<RoleOnly roles={["founder", "manager"]}><Targets /></RoleOnly>} />
        <Route path="executives" element={<RoleOnly roles={["founder", "manager"]}><Executives /></RoleOnly>} />
        <Route path="import" element={<RoleOnly roles={["founder", "manager"]}><ImportPage /></RoleOnly>} />
        <Route path="settings" element={<Settings />} />
        <Route path="ai" element={<AIAssistant />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <FiltersProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" theme="dark" />
          <AppRouter />
        </BrowserRouter>
      </FiltersProvider>
    </AuthProvider>
  );
}

export default App;
